export default "__VITE_ASSET__BKmyqiYs__"